import React, { useState } from "react";
import { TextField, TextareaAutosize, Button } from "@mui/material";
import { signInWithEmailAndPassword } from "firebase/auth";
import { getAuthInstance } from "../../service/firebase/FirebaseService";

interface LoginProps {
  onBack?: () => void;
}

const Login: React.FC<LoginProps> = ({ onBack }) => {
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [token, settoken] = useState<string | undefined>("");

  const handleLogin = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    signInWithEmailAndPassword(getAuthInstance(), email, password).then(
      (userCredentials) => {
        userCredentials.user
          .getIdToken(true)
          .then((t) => settoken(t))
          .catch((error) => console.log(error));
      },
    );
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-6 p-8 bg-white rounded-lg shadow-md">
        {onBack && (
          <button
            onClick={onBack}
            className="flex items-center text-gray-600 hover:text-gray-800 mb-4"
          >
            <span className="mr-2">←</span>
            <span>Back</span>
          </button>
        )}
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900">Login</h2>
        </div>
        <div className="space-y-4">
          <TextField
            id="email"
            label="Email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setemail(e.target.value)}
          />
          <TextField
            id="password"
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setpassword(e.target.value)}
          />
          {token && (
            <TextareaAutosize
              aria-label="Token"
              minRows={3}
              value={token}
              className="w-full p-2 border border-gray-300 rounded-md"
              readOnly
            />
          )}
          <Button
            color="primary"
            fullWidth
            onClick={handleLogin}
            size="large"
            variant="contained"
            className="mt-4"
          >
            Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Login;
